import PromotionInput from './PromotionInput'

export default PromotionInput
